"use strict";

require("core-js/modules/es.array.iterator");

var head = require("./head.js");

var reduce = require("./reduce.js");

var reverseL = require("../Lazy/reverseL.js");

module.exports = reduceRight;

function reduceRight(f, acc, iter) {
  if (arguments.length == 1) return (..._) => reduce(f, ..._);
  if (arguments.length == 2) return reduce(f, head(iter = reverseL(acc)), iter);
  return reduce(f, acc, reverseL(iter));
}